import React, { useEffect, useState } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import emailjs from "@emailjs/browser";
import  Logo from '../assets/image/logo3.png';
import  India from '../assets/image/IndiaFlag.png';

import "./nav&foot.css"; 

const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");


   const handleSubmit = (e) => {
  e.preventDefault();

  const templateParams = {
    to_name: "Rohit Jana",
    user_email: email,
    reply_to: email
  };

  emailjs
    .send(
  "service_6a6dljh",
  "template_5anmnwl",
      templateParams,
      "A7C15SG39c6EYpG7O" // ✅ Make sure it's the public key
    )
    .then(
      (response) => {
        console.log("SUCCESS!", response.status, response.text);
        setMessage("Email sent successfully!");
        setEmail("");
      },
      (error) => {
        console.error("FAILED...", error);
        setMessage("Failed to send email.");
      }
    );
};


  const [contact, setContact] = useState({
    phone: "",
    email: "",
    address: "",
  });

useEffect(() => {
  fetch("https://dashboard.jyotirvani.com/api/contactpage")
    .then((res) => res.json())
    .then((data) => {
      if (data.status && data.data) {
        setContact(data.data);
      }
    })
    .catch((error) =>
      console.error("Error fetching contact info:", error)
    );
}, []);


  return (
    <footer className="tm-footer">
      <div className="container">
        <div className="tm-footer-top">
          <div className="row">
            {/* Logo and Social Icons */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="tm-footer-1">
                <div className="tm-footer-logo">
                  <a
                    href="/"
                    style={{
                      width: "50px",
                      height: "50px",
                    }}
                  >
                    <img src={Logo} alt="Jyotirvani Logo" />
                  </a>
                  
                </div>
              <div className="tm-social-icon">
  {contact.fb && (
    <a href={contact.fb} target="_blank" rel="noopener noreferrer">
      <i className="fab fa-facebook-square"></i>
    </a>
  )}
  {contact.insta && (
    <a href={contact.insta} target="_blank" rel="noopener noreferrer">
      <i className="fab fa-instagram"></i>
    </a>
  )}
</div>

              </div>
            </div>

            {/* Contact Us */}
            <div className="col-lg-3 col-md-6 col-sm-12">
  <div className="tm-footer-2">
    <div className="tm-footer-heading">
      <h3>Contact Us</h3>
    </div>
<div className="tm-footer-contact">
  {contact.phno && (
    <div className="tm-footer-contact-panel">
      <a href={`tel:${contact.phno}`}>
        <i className="fa-solid fa-phone">
          <img
            src={India}
            alt="India Flag"
            style={{
              width: "20px",
              height: "15px",
              marginRight: "1px",
              marginLeft: "5px",
              verticalAlign: "middle",
            }}
          />
        </i>{" "}
        {contact.phno}
      </a>
    </div>
  )}

  {contact.email && (
    <div className="tm-footer-contact-panel">
      <a href={`mailto:${contact.email}`}>
        <i className="fa-solid fa-envelope"></i> {contact.email}
      </a>
    </div>
  )}

  {contact.address && (
    <div className="tm-footer-contact-panel">
      <a
        href={`https://www.google.com/maps?q=${encodeURIComponent(contact.address)}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa-solid fa-map-marker-alt"></i> {contact.address}
      </a>
    </div>
  )}
</div>
          
  </div>
</div>


            {/* Quick Links */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="tm-footer-3">
                <div className="tm-footer-heading">
                  <h3>Quick Links</h3>
                </div>
                <div className="tm-footer-menu">
                  <ul>
                    <li>
                      <a href="/">Home</a>
                    </li>
                    {/* <li>
                      <a href="/IndianConsultan"><img
                  src="image/IndiaFlag.png"
                  alt="USA Flag"
                  style={{
                    width: "20px",
                    height: "15px",
                    marginRight: "10px",

                    verticalAlign: "middle",
                  }}
                />
                National</a>
                    </li> */}
                    {/* <li>
                      <a href="/ForeignbookConsultancy">
                      <img
                  src="image/UnitedFlag.png"
                  alt="USA Flag"
                  style={{
                    width: "20px",
                    height: "15px",
                    marginRight: "10px",

                    verticalAlign: "middle",
                  }}
                />
                International{" "}
                      </a>
                    </li> */}
                    <li>
                      <a href="/AstrologerSection"> Astrologer</a>
                    </li>
                    <li>
                      <a href="/Blog">Blog</a>
                    </li>
                    <li>
                      <a href="/Contact">Contact Us</a>
                    </li>
                    <li>
                      <a href="/PrivacyPolicy"> Privacy Policy</a>
                    </li>
                    <li>
                      <a href="/TermsAndRefund">Terms of Use & Refund Policy</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Newsletter Subscription */}
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="tm-footer-4">
                <div className="tm-footer-heading">
                  <h3>Subscribe Our Newsletter</h3>
                </div>
                <div className="tm-footer-form">
                  <form onSubmit={handleSubmit}>
                    <div className="ra-footer-input mb-3">
                      <input
                        type="email"
                        className="form-control"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">
            Send
          </button>
          {message && <p>{message}</p>}
        </form>
      </div>
    </div>
          </div>
        </div>
        </div>

        {/* Footer Bottom */}
        <div className="tm-footer-bottom">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="tm-copy-right">
                <h4>© 2025 Copyrights. All rights reserved by AstroSeptem</h4>
              </div>
            </div>
            <div className="col-md-6">
              <div className="tm-footer-bottom-right">
                <h4>
                  Design & Developed by <a href="https://www.linkedin.com/in/rohit-jana-06b2a8158?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app">Rohit Jana</a>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
